var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4096 16.8077C11.3684 16.8297 11.3271 16.8395 11.2901 16.835C11.25 16.8301 10.2958 16.71 9.32786 16.2792C8.7542 16.0239 8.29628 15.7116 7.96685 15.351C7.54055 14.8844 7.32617 14.3316 7.32963 13.7079C7.33368 12.9821 7.56253 12.1798 7.97407 11.4489C8.39256 10.7057 8.95105 10.122 9.54668 9.80528C10.31 9.39939 11.008 9.51259 11.4096 10.0662C11.8113 9.08546 12.5092 8.23006 13.2726 7.82417C13.8353 7.52496 14.3722 7.49823 14.7844 7.74887C15.2368 8.02391 15.4938 8.61573 15.4896 9.37253C15.4862 9.99519 15.2678 10.7771 14.8405 11.6966C14.5101 12.4077 14.0528 13.2064 13.4814 14.0704C12.517 15.5285 11.5697 16.6597 11.5298 16.7071C11.4927 16.7513 11.4511 16.7856 11.4096 16.8077Z",
    fill: "url(#paint0_linear_113_1642)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_09"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.66744 17.0132C2.65627 11.6685 6.46904 5.13604 11.0652 2.48271C11.0719 2.47882 11.0785 2.47619 11.0852 2.47233C12.2832 1.78255 13.7351 1.25787 15.1274 1.31632C15.1308 1.31644 15.1342 1.3162 15.1376 1.31635C15.1455 1.31669 15.1536 1.31605 15.1614 1.31644L13.7957 0.539421C8.84628 -2.34181 -0.0182629 6.86441 2.82623e-05 15.2111C0.0102203 17.6516 0.827041 19.469 2.30004 20.3278L3.74003 21.1473C3.73084 21.1334 3.72316 21.1179 3.71409 21.1039C2.95287 19.9301 2.67356 18.4118 2.66744 17.0132Z",
    fill: "url(#paint1_linear_113_1642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3129 2.91395C6.83916 5.49724 3.15342 11.8325 3.16801 17.0125C3.18184 21.9974 6.62248 24.1454 11.1193 21.5496C15.6213 18.9502 19.2724 12.6197 19.2574 7.43801C19.2432 2.32869 15.6721 0.393535 11.3129 2.91395ZM11.3557 18.9733C8.00596 20.9066 5.29742 19.2616 5.28748 15.5093C5.27753 11.8366 7.8718 7.33888 11.0724 5.49011C14.3773 3.58665 17.1306 5.15714 17.1405 8.95408C17.1505 12.6318 14.5562 17.1245 11.3557 18.9733Z",
    fill: "url(#paint2_linear_113_1642)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_1642",
    x1: 7.32959,
    y1: 13.2907,
    x2: 13.6912,
    y2: 9.90817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC628C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_113_1642",
    x1: 0.117496,
    y1: 12.0786,
    x2: 13.9283,
    y2: 12.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A1BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6B81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_113_1642",
    x1: 3.29266,
    y1: 13.7191,
    x2: 17.9488,
    y2: 13.7191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A1BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6B81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMToken);
export default __webpack_public_path__ + "static/media/m-token.aa9f00c205e288b0e4e2f143ec8f2b33.svg";
export { ForwardRef as ReactComponent };